import { Injectable } from '@angular/core';
import { PaymentSheetEventsEnum, PaymentSheetResultInterface, Stripe } from '@capacitor-community/stripe';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class PaymentService {
    constructor() {
        Stripe.initialize({
            publishableKey: environment.publishableKey
        });
    }

    async openPaymentSheet(paymentIntent: string, ephemeralKey: string, customer: string): Promise<PaymentSheetResultInterface> {
        try {
            await Stripe.createPaymentSheet({
                paymentIntentClientSecret: paymentIntent,
                customerId: customer,
                customerEphemeralKeySecret: ephemeralKey,
                merchantDisplayName: 'Luxura'
            });

            // present PaymentSheet and get result.
            const result = await Stripe.presentPaymentSheet();
            switch (result.paymentResult) {
                case PaymentSheetEventsEnum.Completed:
                    console.log('PaymentSheetEventsEnum.Completed');
                    break;
                case PaymentSheetEventsEnum.Canceled:
                    console.log('PaymentSheetEventsEnum.Canceled');
                    break;
                case PaymentSheetEventsEnum.Failed:
                    console.log('PaymentSheetEventsEnum.Failed');
                    break;
                default:
                    console.log('Unknown');
                    break;
            }

            return result.paymentResult;
        } catch (error) {
            console.log('Error: ', error);
            return PaymentSheetEventsEnum.Failed;
        }
    }
}
